import React from "react";
import { useNavigate } from "react-router-dom";
import "./BillingWorkspace.css";

const BillingSourceTabs = ({ activeSource, view = "billing" }) => {
  const navigate = useNavigate();
  const isHistory = view === "history";

  const openSource = (source) => {
    if (isHistory) {
      navigate(source === "attorney" ? "/attorneyinvoicehistory" : "/gladeinvoicehistory");
    } else {
      navigate(source === "attorney" ? "/attorneypendingbilling?course=all" : "/gladebilling");
    }
  };

  return (
    <div className="billing-workspace-heading is-primary-header">
      <h1>{isHistory ? "Invoice History" : "Pending Billing"}</h1>
      <div className="client-tabs" role="tablist" aria-label="Billing source">
        <button
          type="button"
          role="tab"
          aria-selected={activeSource === "attorney"}
          className={activeSource === "attorney" ? "active" : ""}
          onClick={() => openSource("attorney")}
        >
          <i className="fa-solid fa-scale-balanced" aria-hidden="true"></i>
          Attorney
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={activeSource === "glade"}
          className={activeSource === "glade" ? "active" : ""}
          onClick={() => openSource("glade")}
        >
          <i className="fa-solid fa-user-group" aria-hidden="true"></i>
          Glade
        </button>
      </div>
    </div>
  );
};

export default BillingSourceTabs;
